import React, { useContext, useRef, useState } from 'react';
import {
  ImageBackground, StyleSheet, Text, TouchableOpacity, View,
} from 'react-native';
import { Pressable } from 'react-native-web-hover';

import { MIN_SQUEEZE_WIDTH } from '../util/helpers';
import Style from '../style';
import Box from '../components/Box';
import TextInput from '../components/TextInput';
import Button from '../components/Button';
import { RootStoreContext } from '../stores/RootStore';
import I18n from '../i18n';
import bgImg from '../../assets/img/img_bg_login.jpg';

const MFA_CODE_RX = /^\d{6}$/;

const MfaLoginScreen = () => {
  const store = useContext(RootStoreContext);
  const [loading, setLoading] = useState(false);
  const [fieldError, setFieldError] = useState('');
  const codeInput = useRef<TextInput>(null);

  const submit = async () => {
    if (!codeInput.current?.checkAndComplain()) return;

    setFieldError('');
    setLoading(true);
    try {
      await store.auth.verifyMfaLogin(codeInput.current.text);
    } catch (err) {
      const message = err instanceof Error
        ? err.message.toString()
        : String(I18n.t('error.login.mfaInvalidCode'));
      setFieldError(message);
    } finally {
      setLoading(false);
    }
  };

  const cancel = () => {
    store.auth.clearPendingMfaLogin();
  };

  return (
    <ImageBackground source={bgImg} style={styles.wrapper}>
      <Box style={styles.loginBox}>
        <Pressable testID="MfaLoginScreen.BackButton">
          {({ hovered }) => (
            <TouchableOpacity onPress={cancel} disabled={loading}>
              <Text style={[styles.link, hovered && !loading && styles.linkHovered]}>
                {I18n.t('ui.login.backToSignIn')}
              </Text>
            </TouchableOpacity>
          )}
        </Pressable>
        <Text style={styles.heading}>{I18n.t('ui.login.mfaTitle')}</Text>
        <TextInput
          caption={I18n.t('ui.login.mfaCode')}
          hint="123456"
          rx={MFA_CODE_RX}
          errMsg={fieldError || I18n.t('error.login.mfaInvalidCode')}
          disabled={loading}
          ref={codeInput}
          testId="MfaLoginScreen.CodeInput"
          submit={submit}
          keyboardType="number-pad"
          maxLength={6}
          onChange={() => {
            setFieldError('');
          }}
          forceError={!!fieldError}
        />
        <View style={styles.pad}>
          <Button
            onPress={submit}
            title={I18n.t('ui.login.mfaSubmit')}
            loading={loading}
            testId="MfaLoginScreen.SubmitButton"
          />
        </View>
      </Box>
    </ImageBackground>
  );
};
export default MfaLoginScreen;

const styles = StyleSheet.create({
  wrapper: {
    width: '100%',
    height: '100%',
    resizeMode: 'cover',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 10,
  },
  loginBox: {
    width: '100%',
    maxWidth: 424,
    minWidth: MIN_SQUEEZE_WIDTH,
  },
  link: {
    ...Style.Text.Small,
    color: Style.Color.Gray400,
    alignSelf: 'flex-end',
  },
  linkHovered: {
    color: Style.Color.Primary,
    cursor: 'pointer',
  },
  heading: {
    ...Style.Text.Heading1,
    color: Style.Color.Black,
    alignSelf: 'center',
    marginVertical: 20,
  },
  pad: {
    marginTop: 20,
    marginBottom: 8,
  },
});
